/**
 * Color primitives shared verbatim between the RI and Repair Clinic themes.
 * Bodewell has its own cream/navy palette end-to-end and does not import
 * from here — these exist purely to remove literal duplication between the
 * two brands that currently differ only in accent/structural colors.
 *
 * Do not import these into a new brand just to save typing; only reuse a
 * value here if the new brand is genuinely meant to match it. Otherwise
 * define the brand's own palette in its theme file, the same way Bodewell
 * does.
 */

export const sharedUtilityColors = {
  bgBlue: {value: "#E7F0FB"},
  bgGreen: {value: "#E5F6EB"},
  bgRed: {value: "#FFE5E8"},
  bgYellow: {value: "#FDF3DD"},

  fontBlack: {value: "#000000"},
  fontGreen: {value: "#23B558"},
  fontGrey: {value: "#757575"},
  fontRed: {value: "rgb(207, 39, 39)"},
  fontLightRed: {value: "#FF4F68"},

  blue: {value: "#0041C2"},
  darkGrey: {value: "rgb(200, 200, 200)"},
  green: {value: "#0A8035"},
  grey: {value: "#F0F0F0"},
  lightBlue: {value: "#126CD6"},
  lightGrey: {value: "rgb(248, 248, 248)"},
  lineGrey: {value: "#E6E6E6"},
  turquoise: {value: "rgb(0, 163, 224)"},
  white: {value: "#FFFFFF"},
  slateGray: {value: "#595C60"},
  transparentWhite: {value: "rgba(255, 255, 255, 0.2)"},
  lightBlack: {value: "#0C111D"},
}

export const sharedNeutralPalette = {
  50: {value: "#fafafa"},
  100: {value: "#f4f5f6"},
  200: {value: "#e9eaec"},
  300: {value: "#cbcdd0"},
  400: {value: "#a5a8ab"},
  500: {value: "#717174"},
  600: {value: "#4e4f56"},
  700: {value: "#2e2f33"},
  800: {value: "#27272a"},
  900: {value: "#1f1f22"},
  950: {value: "#161618"},
}

export const sharedBaseColors = {
  black: {value: "#000000"},
  white: {value: "#ffffff"},
}

export const sharedSteelFogPalette = {
  50: {value: "#161618"},
  100: {value: "#d1d4d1"},
  200: {value: "#bbc0ba"},
  300: {value: "#a5aba4"},
  400: {value: "#8f978e"},
  500: {value: "#707c6e"},
  600: {value: "#546052"},
  700: {value: "#3e483c"},
  800: {value: "#2d352c"},
  900: {value: "#1f241e"},
  950: {value: "#151915"},
}

export const sharedCopperTaupePalette = {
  50: {value: "#ede9e9"},
  100: {value: "#ddd6d5"},
  200: {value: "#c7bcba"},
  300: {value: "#ac9b99"},
  400: {value: "#917d79"},
  500: {value: "#745d59"},
  600: {value: "#574542"},
  700: {value: "#423533"},
  800: {value: "#312826"},
  900: {value: "#1f1f22"},
  950: {value: "#171312"},
}

// Magenta
export const sharedErrorPalette = {
  50: {value: "#fef0f7"},
  100: {value: "#fde3ea"},
  200: {value: "#efb4c5"},
  300: {value: "#e788a4"},
  400: {value: "#ea668e"},
  500: {value: "#f3447b"},
  600: {value: "#d81354"},
  700: {value: "#9d0c37"},
  800: {value: "#760527"},
  900: {value: "#430a1b"},
  950: {value: "#2b0812"},
}

export const sharedYellowPalette = {
  50: {value: "#fff3db"},
  100: {value: "#fdebc9"},
  200: {value: "#f7cf85"},
  300: {value: "#f9bd4d"},
  400: {value: "#e6991e"},
  500: {value: "#d17a00"},
  600: {value: "#a86200"},
  700: {value: "#855200"},
  800: {value: "#663f00"},
  900: {value: "#1e2113"},
  950: {value: "#14160c"},
}

export const sharedGrayPalette = {
  600: {value: "#344054"},
  700: {value: "#182230"},
}

/** AI accent gradients shared by RI and Repair Clinic (Bodewell uses its own). */
export const sharedAiAccentGradients = {
  aiAccentPrimary: {
    value: "linear-gradient(135deg, #00A3E0 0%, #0041C2 100%)",
  },
  aiAccentDanger: {
    value: "linear-gradient(134deg, #FF8784 -1.91%, #FF2C56 100%)",
  },
}
